import { Country } from '../types';

// source: https://github.com/eesur/country-codes-lat-long/blob/master/country-codes-lat-long-alpha3.json
export const latLongCountries: Country[] = [
  {
    country: 'Albania',
    alpha2: 'AL',
    latitude: 41,
    longitude: 20,
  },
  {
    country: 'Algeria',
    alpha2: 'DZ',
    latitude: 28,
    longitude: 3,
  },
  {
    country: 'American Samoa',
    alpha2: 'AS',
    latitude: -14.3333,
    longitude: -170,
  },
  {
    country: 'Andorra',
    alpha2: 'AD',
    latitude: 42.5,
    longitude: 1.6,
  },
  {
    country: 'Angola',
    alpha2: 'AO',
    latitude: -12.5,
    longitude: 18.5,
  },
  {
    country: 'Anguilla',
    alpha2: 'AI',
    latitude: 18.25,
    longitude: -63.1667,
  },
  {
    country: 'Antarctica',
    alpha2: 'AQ',
    latitude: -90,
    longitude: 0,
  },
  {
    country: 'Antigua and Barbuda',
    alpha2: 'AG',
    latitude: 17.05,
    longitude: -61.8,
  },
  {
    country: 'Argentina',
    alpha2: 'AR',
    latitude: -34,
    longitude: -64,
  },
  {
    country: 'Armenia',
    alpha2: 'AM',
    latitude: 40,
    longitude: 45,
  },
  {
    country: 'Aruba',
    alpha2: 'AW',
    latitude: 12.5,
    longitude: -69.9667,
  },
  {
    country: 'Australia',
    alpha2: 'AU',
    latitude: -27,
    longitude: 133,
  },
  {
    country: 'Austria',
    alpha2: 'AT',
    latitude: 47.3333,
    longitude: 13.3333,
  },
  {
    country: 'Azerbaijan',
    alpha2: 'AZ',
    latitude: 40.5,
    longitude: 47.5,
  },
  {
    country: 'Bahamas',
    alpha2: 'BS',
    latitude: 24.25,
    longitude: -76,
  },
  {
    country: 'Bahrain',
    alpha2: 'BH',
    latitude: 26,
    longitude: 50.55,
  },
  {
    country: 'Bangladesh',
    alpha2: 'BD',
    latitude: 24,
    longitude: 90,
  },
  {
    country: 'Barbados',
    alpha2: 'BB',
    latitude: 13.1667,
    longitude: -59.5333,
  },
  {
    country: 'Belarus',
    alpha2: 'BY',
    latitude: 53,
    longitude: 28,
  },
  {
    country: 'Belgium',
    alpha2: 'BE',
    latitude: 50.8333,
    longitude: 4,
  },
  {
    country: 'Belize',
    alpha2: 'BZ',
    latitude: 17.25,
    longitude: -88.75,
  },
  {
    country: 'Benin',
    alpha2: 'BJ',
    latitude: 9.5,
    longitude: 2.25,
  },
  {
    country: 'Bermuda',
    alpha2: 'BM',
    latitude: 32.3333,
    longitude: -64.75,
  },
  {
    country: 'Bhutan',
    alpha2: 'BT',
    latitude: 27.5,
    longitude: 90.5,
  },
  {
    country: 'Bolivia, Plurinational State of',
    alpha2: 'BO',
    latitude: -17,
    longitude: -65,
  },
  {
    country: 'Bosnia and Herzegovina',
    alpha2: 'BA',
    latitude: 44,
    longitude: 18,
  },
  {
    country: 'Botswana',
    alpha2: 'BW',
    latitude: -22,
    longitude: 24,
  },
  {
    country: 'Bouvet Island',
    alpha2: 'BV',
    latitude: -54.4333,
    longitude: 3.4,
  },
  {
    country: 'Brazil',
    alpha2: 'BR',
    latitude: -10,
    longitude: -55,
  },
  {
    country: 'British Indian Ocean Territory',
    alpha2: 'IO',
    latitude: -6,
    longitude: 71.5,
  },
  {
    country: 'Brunei Darussalam',
    alpha2: 'BN',
    latitude: 4.5,
    longitude: 114.6667,
  },
  {
    country: 'Bulgaria',
    alpha2: 'BG',
    latitude: 43,
    longitude: 25,
  },
  {
    country: 'Burkina Faso',
    alpha2: 'BF',
    latitude: 13,
    longitude: -2,
  },
  {
    country: 'Burundi',
    alpha2: 'BI',
    latitude: -3.5,
    longitude: 30,
  },
  {
    country: 'Cambodia',
    alpha2: 'KH',
    latitude: 13,
    longitude: 105,
  },
  {
    country: 'Cameroon',
    alpha2: 'CM',
    latitude: 6,
    longitude: 12,
  },
  {
    country: 'Canada',
    alpha2: 'CA',
    latitude: 60,
    longitude: -95,
  },
  {
    country: 'Cape Verde',
    alpha2: 'CV',
    latitude: 16,
    longitude: -24,
  },
  {
    country: 'Cayman Islands',
    alpha2: 'KY',
    latitude: 19.5,
    longitude: -80.5,
  },
  {
    country: 'Central African Republic',
    alpha2: 'CF',
    latitude: 7,
    longitude: 21,
  },
  {
    country: 'Chad',
    alpha2: 'TD',
    latitude: 15,
    longitude: 19,
  },
  {
    country: 'Chile',
    alpha2: 'CL',
    latitude: -30,
    longitude: -71,
  },
  {
    country: 'China',
    alpha2: 'CN',
    latitude: 35,
    longitude: 105,
  },
  {
    country: 'Christmas Island',
    alpha2: 'CX',
    latitude: -10.5,
    longitude: 105.6667,
  },
  {
    country: 'Cocos (Keeling) Islands',
    alpha2: 'CC',
    latitude: -12.5,
    longitude: 96.8333,
  },
  {
    country: 'Colombia',
    alpha2: 'CO',
    latitude: 4,
    longitude: -72,
  },
  {
    country: 'Comoros',
    alpha2: 'KM',
    latitude: -12.1667,
    longitude: 44.25,
  },
  {
    country: 'Congo',
    alpha2: 'CG',
    latitude: -1,
    longitude: 15,
  },
  {
    country: 'Congo, the Democratic Republic of the',
    alpha2: 'CD',
    latitude: 0,
    longitude: 25,
  },
  {
    country: 'Cook Islands',
    alpha2: 'CK',
    latitude: -21.2333,
    longitude: -159.7667,
  },
  {
    country: 'Costa Rica',
    alpha2: 'CR',
    latitude: 10,
    longitude: -84,
  },
  {
    country: "Côte d'Ivoire",
    alpha2: 'CI',
    latitude: 8,
    longitude: -5,
  },
  {
    country: 'Croatia',
    alpha2: 'HR',
    latitude: 45.1667,
    longitude: 15.5,
  },
  {
    country: 'Cuba',
    alpha2: 'CU',
    latitude: 21.5,
    longitude: -80,
  },
  {
    country: 'Cyprus',
    alpha2: 'CY',
    latitude: 35,
    longitude: 33,
  },
  {
    country: 'Czech Republic',
    alpha2: 'CZ',
    latitude: 49.75,
    longitude: 15.5,
  },
  {
    country: 'Denmark',
    alpha2: 'DK',
    latitude: 56,
    longitude: 10,
  },
  {
    country: 'Djibouti',
    alpha2: 'DJ',
    latitude: 11.5,
    longitude: 43,
  },
  {
    country: 'Dominica',
    alpha2: 'DM',
    latitude: 15.4167,
    longitude: -61.3333,
  },
  {
    country: 'Dominican Republic',
    alpha2: 'DO',
    latitude: 19,
    longitude: -70.6667,
  },
  {
    country: 'Ecuador',
    alpha2: 'EC',
    latitude: -2,
    longitude: -77.5,
  },
  {
    country: 'Egypt',
    alpha2: 'EG',
    latitude: 27,
    longitude: 30,
  },
  {
    country: 'El Salvador',
    alpha2: 'SV',
    latitude: 13.8333,
    longitude: -88.9167,
  },
  {
    country: 'Equatorial Guinea',
    alpha2: 'GQ',
    latitude: 2,
    longitude: 10,
  },
  {
    country: 'Eritrea',
    alpha2: 'ER',
    latitude: 15,
    longitude: 39,
  },
  {
    country: 'Estonia',
    alpha2: 'EE',
    latitude: 59,
    longitude: 26,
  },
  {
    country: 'Ethiopia',
    alpha2: 'ET',
    latitude: 8,
    longitude: 38,
  },
  {
    country: 'Falkland Islands (Malvinas)',
    alpha2: 'FK',
    latitude: -51.75,
    longitude: -59,
  },
  {
    country: 'Faroe Islands',
    alpha2: 'FO',
    latitude: 62,
    longitude: -7,
  },
  {
    country: 'Fiji',
    alpha2: 'FJ',
    latitude: -18,
    longitude: 175,
  },
  {
    country: 'Finland',
    alpha2: 'FI',
    latitude: 64,
    longitude: 26,
  },
  {
    country: 'France',
    alpha2: 'FR',
    latitude: 46,
    longitude: 2,
  },
  {
    country: 'French Guiana',
    alpha2: 'GF',
    latitude: 4,
    longitude: -53,
  },
  {
    country: 'French Polynesia',
    alpha2: 'PF',
    latitude: -15,
    longitude: -140,
  },
  {
    country: 'French Southern Territories',
    alpha2: 'TF',
    latitude: -43,
    longitude: 67,
  },
  {
    country: 'Gabon',
    alpha2: 'GA',
    latitude: -1,
    longitude: 11.75,
  },
  {
    country: 'Gambia',
    alpha2: 'GM',
    latitude: 13.4667,
    longitude: -16.5667,
  },
  {
    country: 'Georgia',
    alpha2: 'GE',
    latitude: 42,
    longitude: 43.5,
  },
  {
    country: 'Germany',
    alpha2: 'DE',
    latitude: 51,
    longitude: 9,
  },
  {
    country: 'Ghana',
    alpha2: 'GH',
    latitude: 8,
    longitude: -2,
  },
  {
    country: 'Gibraltar',
    alpha2: 'GI',
    latitude: 36.1833,
    longitude: -5.3667,
  },
  {
    country: 'Greece',
    alpha2: 'GR',
    latitude: 39,
    longitude: 22,
  },
  {
    country: 'Greenland',
    alpha2: 'GL',
    latitude: 72,
    longitude: -40,
  },
  {
    country: 'Grenada',
    alpha2: 'GD',
    latitude: 12.1167,
    longitude: -61.6667,
  },
  {
    country: 'Guadeloupe',
    alpha2: 'GP',
    latitude: 16.25,
    longitude: -61.5833,
  },
  {
    country: 'Guam',
    alpha2: 'GU',
    latitude: 13.4667,
    longitude: 144.7833,
  },
  {
    country: 'Guatemala',
    alpha2: 'GT',
    latitude: 15.5,
    longitude: -90.25,
  },
  {
    country: 'Guernsey',
    alpha2: 'GG',
    latitude: 49.5,
    longitude: -2.56,
  },
  {
    country: 'Guinea',
    alpha2: 'GN',
    latitude: 11,
    longitude: -10,
  },
  {
    country: 'Guinea-Bissau',
    alpha2: 'GW',
    latitude: 12,
    longitude: -15,
  },
  {
    country: 'Guyana',
    alpha2: 'GY',
    latitude: 5,
    longitude: -59,
  },
  {
    country: 'Haiti',
    alpha2: 'HT',
    latitude: 19,
    longitude: -72.4167,
  },
  {
    country: 'Heard Island and McDonald Islands',
    alpha2: 'HM',
    latitude: -53.1,
    longitude: 72.5167,
  },
  {
    country: 'Holy See (Vatican City State)',
    alpha2: 'VA',
    latitude: 41.9,
    longitude: 12.45,
  },
  {
    country: 'Honduras',
    alpha2: 'HN',
    latitude: 15,
    longitude: -86.5,
  },
  {
    country: 'Hong Kong',
    alpha2: 'HK',
    latitude: 22.25,
    longitude: 114.1667,
  },
  {
    country: 'Hungary',
    alpha2: 'HU',
    latitude: 47,
    longitude: 20,
  },
  {
    country: 'Iceland',
    alpha2: 'IS',
    latitude: 65,
    longitude: -18,
  },
  {
    country: 'India',
    alpha2: 'IN',
    latitude: 20,
    longitude: 77,
  },
  {
    country: 'Indonesia',
    alpha2: 'ID',
    latitude: -5,
    longitude: 120,
  },
  {
    country: 'Iran, Islamic Republic of',
    alpha2: 'IR',
    latitude: 32,
    longitude: 53,
  },
  {
    country: 'Iraq',
    alpha2: 'IQ',
    latitude: 33,
    longitude: 44,
  },
  {
    country: 'Ireland',
    alpha2: 'IE',
    latitude: 53,
    longitude: -8,
  },
  {
    country: 'Isle of Man',
    alpha2: 'IM',
    latitude: 54.23,
    longitude: -4.55,
  },
  {
    country: 'Israel',
    alpha2: 'IL',
    latitude: 31.5,
    longitude: 34.75,
  },
  {
    country: 'Italy',
    alpha2: 'IT',
    latitude: 42.8333,
    longitude: 12.8333,
  },
  {
    country: 'Jamaica',
    alpha2: 'JM',
    latitude: 18.25,
    longitude: -77.5,
  },
  {
    country: 'Japan',
    alpha2: 'JP',
    latitude: 36,
    longitude: 138,
  },
  {
    country: 'Jersey',
    alpha2: 'JE',
    latitude: 49.21,
    longitude: -2.13,
  },
  {
    country: 'Jordan',
    alpha2: 'JO',
    latitude: 31,
    longitude: 36,
  },
  {
    country: 'Kazakhstan',
    alpha2: 'KZ',
    latitude: 48,
    longitude: 68,
  },
  {
    country: 'Kenya',
    alpha2: 'KE',
    latitude: 1,
    longitude: 38,
  },
  {
    country: 'Kiribati',
    alpha2: 'KI',
    latitude: 1.4167,
    longitude: 173,
  },
  {
    country: "Korea, Democratic People's Republic of",
    alpha2: 'KP',
    latitude: 40,
    longitude: 127,
  },
  {
    country: 'Korea, Republic of',
    alpha2: 'KR',
    latitude: 37,
    longitude: 127.5,
  },
  {
    country: 'Kuwait',
    alpha2: 'KW',
    latitude: 29.3375,
    longitude: 47.6581,
  },
  {
    country: 'Kyrgyzstan',
    alpha2: 'KG',
    latitude: 41,
    longitude: 75,
  },
  {
    country: "Lao People's Democratic Republic",
    alpha2: 'LA',
    latitude: 18,
    longitude: 105,
  },
  {
    country: 'Latvia',
    alpha2: 'LV',
    latitude: 57,
    longitude: 25,
  },
  {
    country: 'Lebanon',
    alpha2: 'LB',
    latitude: 33.8333,
    longitude: 35.8333,
  },
  {
    country: 'Lesotho',
    alpha2: 'LS',
    latitude: -29.5,
    longitude: 28.5,
  },
  {
    country: 'Liberia',
    alpha2: 'LR',
    latitude: 6.5,
    longitude: -9.5,
  },
  {
    country: 'Libyan Arab Jamahiriya',
    alpha2: 'LY',
    latitude: 25,
    longitude: 17,
  },
  {
    country: 'Liechtenstein',
    alpha2: 'LI',
    latitude: 47.1667,
    longitude: 9.5333,
  },
  {
    country: 'Lithuania',
    alpha2: 'LT',
    latitude: 56,
    longitude: 24,
  },
  {
    country: 'Luxembourg',
    alpha2: 'LU',
    latitude: 49.75,
    longitude: 6.1667,
  },
  {
    country: 'Macao',
    alpha2: 'MO',
    latitude: 22.1667,
    longitude: 113.55,
  },
  {
    country: 'Macedonia, the former Yugoslav Republic of',
    alpha2: 'MK',
    latitude: 41.8333,
    longitude: 22,
  },
  {
    country: 'Madagascar',
    alpha2: 'MG',
    latitude: -20,
    longitude: 47,
  },
  {
    country: 'Malawi',
    alpha2: 'MW',
    latitude: -13.5,
    longitude: 34,
  },
  {
    country: 'Malaysia',
    alpha2: 'MY',
    latitude: 2.5,
    longitude: 112.5,
  },
  {
    country: 'Maldives',
    alpha2: 'MV',
    latitude: 3.25,
    longitude: 73,
  },
  {
    country: 'Mali',
    alpha2: 'ML',
    latitude: 17,
    longitude: -4,
  },
  {
    country: 'Malta',
    alpha2: 'MT',
    latitude: 35.8333,
    longitude: 14.5833,
  },
  {
    country: 'Marshall Islands',
    alpha2: 'MH',
    latitude: 9,
    longitude: 168,
  },
  {
    country: 'Martinique',
    alpha2: 'MQ',
    latitude: 14.6667,
    longitude: -61,
  },
  {
    country: 'Mauritania',
    alpha2: 'MR',
    latitude: 20,
    longitude: -12,
  },
  {
    country: 'Mauritius',
    alpha2: 'MU',
    latitude: -20.2833,
    longitude: 57.55,
  },
  {
    country: 'Mayotte',
    alpha2: 'YT',
    latitude: -12.8333,
    longitude: 45.1667,
  },
  {
    country: 'Mexico',
    alpha2: 'MX',
    latitude: 23,
    longitude: -102,
  },
  {
    country: 'Micronesia, Federated States of',
    alpha2: 'FM',
    latitude: 6.9167,
    longitude: 158.25,
  },
  {
    country: 'Moldova, Republic of',
    alpha2: 'MD',
    latitude: 47,
    longitude: 29,
  },
  {
    country: 'Monaco',
    alpha2: 'MC',
    latitude: 43.7333,
    longitude: 7.4,
  },
  {
    country: 'Mongolia',
    alpha2: 'MN',
    latitude: 46,
    longitude: 105,
  },
  {
    country: 'Montenegro',
    alpha2: 'ME',
    latitude: 42,
    longitude: 19,
  },
  {
    country: 'Montserrat',
    alpha2: 'MS',
    latitude: 16.75,
    longitude: -62.2,
  },
  {
    country: 'Morocco',
    alpha2: 'MA',
    latitude: 32,
    longitude: -5,
  },
  {
    country: 'Mozambique',
    alpha2: 'MZ',
    latitude: -18.25,
    longitude: 35,
  },
  {
    country: 'Myanmar',
    alpha2: 'MM',
    latitude: 22,
    longitude: 98,
  },
  {
    country: 'Namibia',
    alpha2: 'NA',
    latitude: -22,
    longitude: 17,
  },
  {
    country: 'Nauru',
    alpha2: 'NR',
    latitude: -0.5333,
    longitude: 166.9167,
  },
  {
    country: 'Nepal',
    alpha2: 'NP',
    latitude: 28,
    longitude: 84,
  },
  {
    country: 'Netherlands',
    alpha2: 'NL',
    latitude: 52.5,
    longitude: 5.75,
  },
  {
    country: 'Netherlands Antilles',
    alpha2: 'AN',
    latitude: 12.25,
    longitude: -68.75,
  },
  {
    country: 'New Caledonia',
    alpha2: 'NC',
    latitude: -21.5,
    longitude: 165.5,
  },
  {
    country: 'New Zealand',
    alpha2: 'NZ',
    latitude: -41,
    longitude: 174,
  },
  {
    country: 'Nicaragua',
    alpha2: 'NI',
    latitude: 13,
    longitude: -85,
  },
  {
    country: 'Niger',
    alpha2: 'NE',
    latitude: 16,
    longitude: 8,
  },
  {
    country: 'Nigeria',
    alpha2: 'NG',
    latitude: 10,
    longitude: 8,
  },
  {
    country: 'Niue',
    alpha2: 'NU',
    latitude: -19.0333,
    longitude: -169.8667,
  },
  {
    country: 'Norfolk Island',
    alpha2: 'NF',
    latitude: -29.0333,
    longitude: 167.95,
  },
  {
    country: 'Northern Mariana Islands',
    alpha2: 'MP',
    latitude: 15.2,
    longitude: 145.75,
  },
  {
    country: 'Norway',
    alpha2: 'NO',
    latitude: 62,
    longitude: 10,
  },
  {
    country: 'Oman',
    alpha2: 'OM',
    latitude: 21,
    longitude: 57,
  },
  {
    country: 'Pakistan',
    alpha2: 'PK',
    latitude: 30,
    longitude: 70,
  },
  {
    country: 'Palau',
    alpha2: 'PW',
    latitude: 7.5,
    longitude: 134.5,
  },
  {
    country: 'Palestinian Territory, Occupied',
    alpha2: 'PS',
    latitude: 32,
    longitude: 35.25,
  },
  {
    country: 'Panama',
    alpha2: 'PA',
    latitude: 9,
    longitude: -80,
  },
  {
    country: 'Papua New Guinea',
    alpha2: 'PG',
    latitude: -6,
    longitude: 147,
  },
  {
    country: 'Paraguay',
    alpha2: 'PY',
    latitude: -23,
    longitude: -58,
  },
  {
    country: 'Peru',
    alpha2: 'PE',
    latitude: -10,
    longitude: -76,
  },
  {
    country: 'Philippines',
    alpha2: 'PH',
    latitude: 13,
    longitude: 122,
  },
  {
    country: 'Pitcairn',
    alpha2: 'PN',
    latitude: -24.7,
    longitude: -127.4,
  },
  {
    country: 'Poland',
    alpha2: 'PL',
    latitude: 52,
    longitude: 20,
  },
  {
    country: 'Portugal',
    alpha2: 'PT',
    latitude: 39.5,
    longitude: -8,
  },
  {
    country: 'Puerto Rico',
    alpha2: 'PR',
    latitude: 18.25,
    longitude: -66.5,
  },
  {
    country: 'Qatar',
    alpha2: 'QA',
    latitude: 25.5,
    longitude: 51.25,
  },
  {
    country: 'Réunion',
    alpha2: 'RE',
    latitude: -21.1,
    longitude: 55.6,
  },
  {
    country: 'Romania',
    alpha2: 'RO',
    latitude: 46,
    longitude: 25,
  },
  {
    country: 'Russian Federation',
    alpha2: 'RU',
    latitude: 60,
    longitude: 100,
  },
  {
    country: 'Rwanda',
    alpha2: 'RW',
    latitude: -2,
    longitude: 30,
  },
  {
    country: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha2: 'SH',
    latitude: -15.9333,
    longitude: -5.7,
  },
  {
    country: 'Saint Kitts and Nevis',
    alpha2: 'KN',
    latitude: 17.3333,
    longitude: -62.75,
  },
  {
    country: 'Saint Lucia',
    alpha2: 'LC',
    latitude: 13.8833,
    longitude: -61.1333,
  },
  {
    country: 'Saint Pierre and Miquelon',
    alpha2: 'PM',
    latitude: 46.8333,
    longitude: -56.3333,
  },
  {
    country: 'Saint Vincent and the Grenadines',
    alpha2: 'VC',
    latitude: 13.25,
    longitude: -61.2,
  },
  {
    country: 'Samoa',
    alpha2: 'WS',
    latitude: -13.5833,
    longitude: -172.3333,
  },
  {
    country: 'San Marino',
    alpha2: 'SM',
    latitude: 43.7667,
    longitude: 12.4167,
  },
  {
    country: 'Sao Tome and Principe',
    alpha2: 'ST',
    latitude: 1,
    longitude: 7,
  },
  {
    country: 'Saudi Arabia',
    alpha2: 'SA',
    latitude: 25,
    longitude: 45,
  },
  {
    country: 'Senegal',
    alpha2: 'SN',
    latitude: 14,
    longitude: -14,
  },
  {
    country: 'Serbia',
    alpha2: 'RS',
    latitude: 44,
    longitude: 21,
  },
  {
    country: 'Seychelles',
    alpha2: 'SC',
    latitude: -4.5833,
    longitude: 55.6667,
  },
  {
    country: 'Sierra Leone',
    alpha2: 'SL',
    latitude: 8.5,
    longitude: -11.5,
  },
  {
    country: 'Singapore',
    alpha2: 'SG',
    latitude: 1.3667,
    longitude: 103.8,
  },
  {
    country: 'Slovakia',
    alpha2: 'SK',
    latitude: 48.6667,
    longitude: 19.5,
  },
  {
    country: 'Slovenia',
    alpha2: 'SI',
    latitude: 46,
    longitude: 15,
  },
  {
    country: 'Solomon Islands',
    alpha2: 'SB',
    latitude: -8,
    longitude: 159,
  },
  {
    country: 'Somalia',
    alpha2: 'SO',
    latitude: 10,
    longitude: 49,
  },
  {
    country: 'South Africa',
    alpha2: 'ZA',
    latitude: -29,
    longitude: 24,
  },
  {
    country: 'South Georgia and the South Sandwich Islands',
    alpha2: 'GS',
    latitude: -54.5,
    longitude: -37,
  },
  {
    country: 'Spain',
    alpha2: 'ES',
    latitude: 40,
    longitude: -4,
  },
  {
    country: 'Sri Lanka',
    alpha2: 'LK',
    latitude: 7,
    longitude: 81,
  },
  {
    country: 'Sudan',
    alpha2: 'SD',
    latitude: 15,
    longitude: 30,
  },
  {
    country: 'Suriname',
    alpha2: 'SR',
    latitude: 4,
    longitude: -56,
  },
  {
    country: 'Svalbard and Jan Mayen',
    alpha2: 'SJ',
    latitude: 78,
    longitude: 20,
  },
  {
    country: 'Swaziland',
    alpha2: 'SZ',
    latitude: -26.5,
    longitude: 31.5,
  },
  {
    country: 'Sweden',
    alpha2: 'SE',
    latitude: 62,
    longitude: 15,
  },
  {
    country: 'Switzerland',
    alpha2: 'CH',
    latitude: 47,
    longitude: 8,
  },
  {
    country: 'Syrian Arab Republic',
    alpha2: 'SY',
    latitude: 35,
    longitude: 38,
  },
  {
    country: 'Taiwan, Province of China',
    alpha2: 'TW',
    latitude: 23.5,
    longitude: 121,
  },
  {
    country: 'Tajikistan',
    alpha2: 'TJ',
    latitude: 39,
    longitude: 71,
  },
  {
    country: 'Tanzania, United Republic of',
    alpha2: 'TZ',
    latitude: -6,
    longitude: 35,
  },
  {
    country: 'Thailand',
    alpha2: 'TH',
    latitude: 15,
    longitude: 100,
  },
  {
    country: 'Timor-Leste',
    alpha2: 'TL',
    latitude: -8.55,
    longitude: 125.5167,
  },
  {
    country: 'Togo',
    alpha2: 'TG',
    latitude: 8,
    longitude: 1.1667,
  },
  {
    country: 'Tokelau',
    alpha2: 'TK',
    latitude: -9,
    longitude: -172,
  },
  {
    country: 'Tonga',
    alpha2: 'TO',
    latitude: -20,
    longitude: -175,
  },
  {
    country: 'Trinidad and Tobago',
    alpha2: 'TT',
    latitude: 11,
    longitude: -61,
  },
  {
    country: 'Tunisia',
    alpha2: 'TN',
    latitude: 34,
    longitude: 9,
  },
  {
    country: 'Turkey',
    alpha2: 'TR',
    latitude: 39,
    longitude: 35,
  },
  {
    country: 'Turkmenistan',
    alpha2: 'TM',
    latitude: 40,
    longitude: 60,
  },
  {
    country: 'Turks and Caicos Islands',
    alpha2: 'TC',
    latitude: 21.75,
    longitude: -71.5833,
  },
  {
    country: 'Tuvalu',
    alpha2: 'TV',
    latitude: -8,
    longitude: 178,
  },
  {
    country: 'Uganda',
    alpha2: 'UG',
    latitude: 1,
    longitude: 32,
  },
  {
    country: 'Ukraine',
    alpha2: 'UA',
    latitude: 49,
    longitude: 32,
  },
  {
    country: 'United Arab Emirates',
    alpha2: 'AE',
    latitude: 24,
    longitude: 54,
  },
  {
    country: 'United Kingdom',
    alpha2: 'GB',
    latitude: 54,
    longitude: -2,
  },
  {
    country: 'United States',
    alpha2: 'US',
    latitude: 38,
    longitude: -97,
  },
  {
    country: 'United States Minor Outlying Islands',
    alpha2: 'UM',
    latitude: 19.2833,
    longitude: 166.6,
  },
  {
    country: 'Uruguay',
    alpha2: 'UY',
    latitude: -33,
    longitude: -56,
  },
  {
    country: 'Uzbekistan',
    alpha2: 'UZ',
    latitude: 41,
    longitude: 64,
  },
  {
    country: 'Vanuatu',
    alpha2: 'VU',
    latitude: -16,
    longitude: 167,
  },
  {
    country: 'Venezuela, Bolivarian Republic of',
    alpha2: 'VE',
    latitude: 8,
    longitude: -66,
  },
  {
    country: 'Viet Nam',
    alpha2: 'VN',
    latitude: 16,
    longitude: 106,
  },
  {
    country: 'Virgin Islands, British',
    alpha2: 'VG',
    latitude: 18.5,
    longitude: -64.5,
  },
  {
    country: 'Virgin Islands, U.S.',
    alpha2: 'VI',
    latitude: 18.3333,
    longitude: -64.8333,
  },
  {
    country: 'Wallis and Futuna',
    alpha2: 'WF',
    latitude: -13.3,
    longitude: -176.2,
  },
  {
    country: 'Western Sahara',
    alpha2: 'EH',
    latitude: 24.5,
    longitude: -13,
  },
  {
    country: 'Yemen',
    alpha2: 'YE',
    latitude: 15,
    longitude: 48,
  },
  {
    country: 'Zambia',
    alpha2: 'ZM',
    latitude: -15,
    longitude: 30,
  },
  {
    country: 'Zimbabwe',
    alpha2: 'ZW',
    latitude: -20,
    longitude: 30,
  },
  {
    country: 'Afghanistan',
    alpha2: 'AF',
    latitude: 33,
    longitude: 65,
  },
  {
    country: 'Europe',
    alpha2: 'EU',
    latitude: 47.75,
    longitude: 1.67,
  },
];
